// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentOutlinedSvg from "@ant-design/icons-svg/es/asn/EnvironmentOutlined";
import AntdIcon from '../components/AntdIcon';

var EnvironmentOutlined = function EnvironmentOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentOutlinedSvg
  }));
};

EnvironmentOutlined.displayName = 'EnvironmentOutlined';
export default React.forwardRef(EnvironmentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EnvironmentOutlined.js
// module id = 1015
// module chunks = 0